import { render } from "./MyPageBookmark.vue?vue&type=template&id=be2dc640"
import script from "./MyPageBookmark.vue?vue&type=script&lang=js"
export * from "./MyPageBookmark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__